export function generateProductName({ type = '', brand = '', group = '' }) {
    // Cria um array só com os valores que existem e não estão vazios
    const parts = [];

    if (type) parts.push(type);
    if (brand) parts.push(brand);
    if (group) parts.push(group);

    // Junta com espaço e retorna
    return parts.join(' ');
}
